// extracted by mini-css-extract-plugin
export var cardHeader = "_ri-0";
export var reorderHandle = "_ri-3";
export var titleArea = "_ri-1";
export var titleAreaWithHandle = "_ri-2";